'use client';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideNotification } from '../../redux/reducers/uiReducer';

const NotificationCenter = () => {
  const dispatch = useDispatch();
  const { notifications } = useSelector(state => state.ui);
  const timersRef = React.useRef({});

  useEffect(() => {
    notifications.forEach(notification => {
      if (timersRef.current[notification.id]) return;
      if (notification.duration && notification.duration > 0) {
        timersRef.current[notification.id] = setTimeout(() => {
          dispatch(hideNotification(notification.id));
          delete timersRef.current[notification.id];
        }, notification.duration);
      }
    });

    const activeIds = new Set(notifications.map(n => n.id));
    Object.keys(timersRef.current).forEach(id => {
      if (!activeIds.has(id)) {
        clearTimeout(timersRef.current[id]);
        delete timersRef.current[id];
      }
    });
  }, [notifications, dispatch]);
  
  const closeNotification = (id) => {
    dispatch(hideNotification(id));
  };
  
  // Si aucune notification, ne rien afficher
  if (notifications.length === 0) {
    return null;
  }
  
  return (
    <div className="notification-center">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`notification-toast ${notification.type}`}
        >
          <div className={`notification-icon ${notification.type}`}>
            {notification.type === 'success' && <i className="material-icons">check_circle</i>}
            {notification.type === 'error' && <i className="material-icons">error</i>}
            {notification.type === 'info' && <i className="material-icons">info</i>}
            {notification.type === 'warning' && <i className="material-icons">warning</i>}
          </div>
          
          <div className="notification-content">
            {notification.title && (
              <div className="notification-title">{notification.title}</div>
            )}
            <div className="notification-message">{notification.message}</div>
            
            <button
              className="notification-close"
              onClick={() => closeNotification(notification.id)}
              aria-label="Fermer"
            >
              <i className="material-icons">close</i>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationCenter;